import { useTranslation } from 'react-i18next';

import { selectableLanguages } from 'locales/i18n';

import { Select, SelectProps } from './uikit';

const languageNames: Record<string, { short: string; long: string }> = {
  en: { short: 'En', long: 'English' },
  ru: { short: 'Ru', long: 'Русский' },
  hi: { short: 'Hi', long: 'हिन्दी' },
  bn: { short: 'Bn', long: 'বাংলা' },
  ta: { short: 'Ta', long: 'தமிழ்' },
  pt: { short: 'Pt', long: 'Português' },
};

function getLanguageName(lng: string, longNames: boolean) {
  const names = languageNames[lng];
  if (!names) return '';
  return longNames ? names.long : names.short;
}

interface SelectLanguageProps extends Omit<SelectProps<string>, 'children'> {
  longNames?: boolean;
  languages?: string[];
  // localStorage key the choice is persisted under
  storageKey?: string;
}

export function SelectLanguage({
  longNames = false,
  languages = selectableLanguages,
  storageKey = 'i18n',
  ...props
}: SelectLanguageProps) {
  const { i18n } = useTranslation();

  return (
    <Select<string>
      w='64px'
      size='sm'
      value={i18n.language}
      onChange={(value) => {
        localStorage.setItem(storageKey, value);
        i18n.changeLanguage(value);
      }}
      {...props}
    >
      {languages.map((lang) => (
        <option key={lang} value={lang}>
          {getLanguageName(lang, longNames)}
        </option>
      ))}
    </Select>
  );
}
